import { hexToRgba } from '@phishtool/ui';
import styled from 'styled-components';
export const StyledExpandableContentWrapper = styled.div.withConfig({ displayName: "StyledExpandableContentWrapper", componentId: "sc-9uab4t" }) `
  border-radius: ${(props) => props.theme.radii.primary};
  box-shadow: 0 0 0 1px ${(props) => props.theme.colors.heroOrange},
    0 5px 40px 0 ${(props) => hexToRgba(props.theme.colors.darkEclipse, 0.2)};
  padding: ${(props) => props.theme.spacers.x3};
  cursor: pointer;
`;
export const StyledExpandableContent = styled.div.withConfig({ displayName: "StyledExpandableContent", componentId: "sc-f8g1qf" }) `
  height: 0;
  overflow: hidden;
  transition: height 0.25s ease-in-out;
`;
